import axios from 'axios'
const uri = 'gestion-grupos/php/'

const get = (url) => {
	return axios.get(uri + url)
}

const post = (url, datos) => {
	return axios.post(uri + url, datos)
}

export default {
	getListado () {
		return get('listado-grupos.php')
	},
	getGrupo (idGrupo) {
		return get('get-grupo.php?ID_grupo=' + idGrupo)
	},
	setGrupo (datos) {
		const form = _.clone(datos)
		form.usuarios = []
		for (let i = 0; i < datos.usuarios.length; i++) {
			form.usuarios.push(datos.usuarios[i].ID)
		}
		return post('set-grupo.php', form)
	},

	delGrupo (idGrupo) {
		const datos = {
			ID_grupo: idGrupo
		}
		return post('del-grupo.php', datos)
	}
}



// WEBPACK FOOTER //
// ./src/modulos/gestion-grupos/vue/api.js